
export enum CustomButtonType {
	positive = "positive",
	negative = "negative",
	buttonNoPreference = "button-no-preference",
}

export enum CustomButtoState {
	enabled = "enabled",
	disabled = "disabled",
	loading = "loading",
}